import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;
export const searchFieldWidth = '85%';
export const previewWidth = '15%';
export const additionalHeight = '560px';
export const additionalThirdPartyHeight = '470px';

export const mainData: Array<any> = [
  [{
    fieldName: 'filename',
    width: '100%',
  }],
  [{
    fieldName: 'file_path',
    width: '100%',
    isThirdPartyAsset: true,
  }],
  [{
    fieldName: 'asset_type',
    width: '50%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'representation',
    width: '50%',
    type: DetailsControlType.Select,
  }],
];

export const additionalData: Array<any> = [
  [{
    fieldName: 'description',
    width: '100%',
  }],
  [{
    fieldName: 'additional_info',
    width: '100%',
  }],
  [{
    fieldName: 'color_mode',
    width: '50%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'resolution',
    width: '50%',
    type: DetailsControlType.Select,
  }],
  [{
    fieldName: 'background',
    width: '50%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'orientation_view',
    width: '50%',
    type: DetailsControlType.Select,
  }],
  [{
    fieldName: 'file_date_modified',
    width: '50%',
    type: DetailsControlType.Date,
  },
  {
    fieldName: 'effective_date',
    width: '50%',
    type: DetailsControlType.Date,
  }],
  [{
    fieldName: 'expiration_date',
    width: '50%',
    type: DetailsControlType.Date,
  },
  {
    fieldName: 'country',
    width: '50%',
    type: DetailsControlType.Select,
  }],
  [{
    fieldName: 'language',
    width: 'calc(50% - 20px)',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'file_type',
    width: 'calc(50% - 20px)',
    type: DetailsControlType.Select,
    isThirdPartyAsset: true,
  }],
  [{
    fieldName: 'width',
    width: '50%',
    isThirdPartyAsset: true,
    numerical: true,
  },
  {
    fieldName: 'height',
    width: '50%',
    isThirdPartyAsset: true,
    numerical: true,
  }],
  [{
    fieldName: 'uom',
    width: '50%',
    type: DetailsControlType.Select,
    isThirdPartyAsset: true,
  },
  {
    fieldName: 'file_size',
    width: '50%',
    isThirdPartyAsset: true,
  }],
  [{
    fieldName: 'frame',
    width: '50%',
  },
  {
    fieldName: 'total_frame',
    width: '50%',
  }],
  [{
    fieldName: 'hemisphere',
    width: '50%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'plunge',
    width: '50%',
  }],
  [{
    fieldName: 'plane',
    width: '50%',
  },
  {
    fieldName: 'total_planes',
    width: '50%',
  }],
  [{
    fieldName: 'duration',
    width: '50%',
  },
  {
    fieldName: 'duration_uom',
    width: '50%',
    type: DetailsControlType.Select,
  }]
];
export const loopingData: Array<any> = [
  // [{
  //   fieldName: 'asc',
  //   width: '100%',
  // }],
  // [{
  //   fieldName: 'des',
  //   width: '100%',
  // }]
];
